import SingleEventPage from "../../components/single-event-page/SingleEventPage";
import PaperPresentationImg from "../../assets/event-images/paperpresentation.jpg";

const paperPresentation = {
  image: PaperPresentationImg,
  description:
    "Action is the foundational key to success--Pablo Picasso. Elevate your ideas and let you ideas fly high along with your presentation.",
  type: "Elite Event",
  eventName: "Paper presentation",
  dateTime: "Feb 28, 10:00AM",
  venue: "IT Block",
  rules: [
    "Solo or Team Participation (1 to 4 per team).",
"Participants must create a presentation based on their chosen topic.",
"The duration of the presentation should not exceed 10 minutes, followed by a Q&A session.",
"Teams can be composed of individuals from different institutions.",
"Participants can participate in two different teams, but they must register separately.",
"Participants may present multiple topics, but they must register each one separately.",
"Paper abstract should not exceed 250 words.",
"Avoid animations and video formats in your PPT.",
"Certificates and prizes for winners, and certificates will be provided for all participants (Hardcopy)."
],

  firstprize: 1500,
  secondprize: 1000,
  thirdprize: 0,
  contact: [
    {
      name: "Vishnu Sayas",
      phoneNo: "6374384534",
    },
    {
      name: "Vasan",
      phoneNo: "9894188149",
    },
  ],
};

const PaperPresentation = () => {
  return (
    <SingleEventPage
      eventDetails={paperPresentation}
      formsLink={"https://docs.google.com/forms/d/e/1FAIpQLSd_hyZZ836FlMQUP4GUpc6NnnNUEWdrboqx9RjIho-ejDSTcg/viewform?usp=dialog"}
    />
  );
};

export default PaperPresentation;
